import api from './api';

const parentService = {
  // Send request from player to add parent
  sendRequestFromPlayerToAddParent: async (parentUsername, roles) => {
    const response = await api.post('/parent/send-request-from-player-to-add-parent', {
      parentUsername,
      role: roles
    });
    return response.data;
  },

  // Send request from parent to add player
  sendRequestFromParentToAddPlayer: async (playerUsername, roles) => {
    const response = await api.post('/parent/send-request-from-parent-to-add-player', {
      playerUsername,
      role: roles
    });
    return response.data;
  },

  // Delete request from player to add parent
  deleteRequestFromPlayerToAddParent: async (requestId) => {
    const response = await api.delete('/parent/delete-request-from-player-to-add-parent', {
      data: { requestId }
    });
    return response.data;
  },

  // Delete request from parent to add player
  deleteRequestFromParentToAddPlayer: async (requestId) => {
    const response = await api.delete('/parent/delete-request-from-parent-to-add-player', {
      data: { requestId }
    });
    return response.data;
  },

  // Get all sent requests
  getAllSentRequestsToAddParent: async () => {
    const response = await api.get('/parent/get-all-sent-requests-to-add-parent');
    return response.data;
  },

  // Get all received requests
  getAllReceivedRequestsToAddParent: async () => {
    const response = await api.get('/parent/get-all-received-requests-to-add-parent');
    return response.data;
  },

  // Approve or reject request
  approveOrRejectRequestToAddParent: async (requestId, status) => {
    const response = await api.put('/parent/approve-or-reject-request-to-add-parent', {
      requestId,
      status // 'approved' or 'rejected'
    });
    return response.data;
  },

  // Get all parents of player
  getAllParentsOfPlayer: async () => {
    const response = await api.get('/parent/get-all-parents-of-player');
    return response.data;
  },

  // Get all players of parent
  getAllPlayersOfParent: async () => {
    const response = await api.get('/parent/get-all-players-of-parent');
    return response.data;
  },

  // Delete parent from user (remove relationship)
  deleteParentFromUser: async (deletedUserId) => {
    const response = await api.delete('/parent/delete-parent-from-user', {
      data: { deletedUserId }
    });
    return response.data;
  },

  // Search for parent or child by username
  searchForParentOrChildByUsername: async (username) => {
    const response = await api.get('/parent/search-for-parent-or-child-by-username', {
      params: { username }
    });
    return response.data;
  }
};

export default parentService; 